import { buildCrud } from './clients';

export default (client) => buildCrud(client, 'inboxes');
